// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__GhkY-","col":"CardReaderDesc_col__3SshB","label":"CardReaderDesc_label__3TmWy"};